@import 'styles/mixins';
@import 'styles/variables';

.container {
  position: relative;

  .dropdown {
    display: none;
    visibility: hidden;
    opacity: 0;
    position: absolute;
    top: 100%;
    z-index: z-index(modal);
    transition: opacity 0.3s;
    max-height: 100vh;

    @include for-phone-only {
      right: 50%;
    }
  }

  .dropUp {
    bottom: 100%;
    top: unset;
  }

  .trigger {
    position: relative;
  }

  .hoverTrigger:hover + .dropdown, // when in hover mode and hovering the trigger
  .hoverTrigger + .dropdown:hover, // when in hover mode and already in the dropdown
  .dropdown.showDropdown {
    display: initial;
    // when in click mode and triggered
    visibility: visible;
    opacity: 1;
  }
}

// NOTE: import this file and use these styles for your own menus
.dropdownContainer {
  @include shadow-2;
  @include ui-md-text;

  background-color: $white;
  border-radius: 8px;
  border: 1px solid $gray-20;
  color: $almanac-black;
  padding: 8px;
}

.dropdownList {
  margin: 0;
  width: 144px;

  li {
    @include ui-md-text;

    color: $gray-90;
    padding: 6px 8px;

    &:hover {
      background-color: $gray-5;
      border-radius: 4px;
    }

    button {
      align-items: center;
      box-sizing: content-box;
      display: flex;
      height: 100%;
      text-align: left;
      margin: -6px -8px;
      padding: 6px 8px;
      width: 100%;

      &.active:after {
        content: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M14.3536 3.64645C14.5488 3.84171 14.5488 4.15829 14.3536 4.35355L6.35355 12.3536C6.15829 12.5488 5.84171 12.5488 5.64645 12.3536L1.64645 8.35355C1.45118 8.15829 1.45118 7.84171 1.64645 7.64645C1.84171 7.45118 2.15829 7.45118 2.35355 7.64645L6 11.2929L13.6464 3.64645C13.8417 3.45118 14.1583 3.45118 14.3536 3.64645Z' fill='black'/%3E%3C/svg%3E%0A");
        display: inline-block;
        margin-left: auto;
      }
    }
  }
}
